import Vue from "vue";
import vMoney from "v-money";

Vue.use(vMoney, { precision: 2 });

export default vMoney;
